<template>
  <div style="display: block">
    <v-menu>
      <template #activator="{ on, attrs }">
        <v-btn 
          color="primary" dark
          v-on="on" :attrs="attrs"
          x-small rounded
        >
          {{ value }}
        </v-btn>
      </template>
      
      <v-list dense class="py-0">
        <template v-for="(item, index) in items">
          <v-divider v-if="index>0" :key="`d-${index}`"/>
          <v-list-item :key="index" @click="statusClick(item)">
            <v-list-item-title>{{ item }}</v-list-item-title>
          </v-list-item>
        </template>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'Status',

  props: ['value'],

  data() {
    return {
      items: [ "open", "won", "lost" ],
    }
  },

  methods: {
    statusClick(newVal) {
      this.$emit('input', newVal)
    },
  },
}
</script>
